function initClearLogs() {
  document.getElementById("clear-logs").addEventListener("click", (e) => {
    [].slice
      .call(document.getElementsByClassName("event-row"))
      .forEach((el) => el.remove());
  });
}

export default initClearLogs;
